import React, {useState} from 'react';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import styled from '@mui/system/styled';
import theme from '../theme/theme';

const TabsContainer = ({tabHeaders, tabContents}) => {
  const [tab, setTab] = useState(0);

  const onTabChange = (_, newValue) => {
    setTab(newValue);
  };

  const _renderHeaders = () =>
    tabHeaders.map((obj, index) => <CustomTab key={obj} label={obj} value={index} />);

  const _renderContents = () =>
    tabContents.map((obj, index) => <TabPanel key={index} value={index}>{obj}</TabPanel>);

  return (
    <TabContext value={tab}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          margin: {xs: '1rem 0', sm: '2rem 0 1rem 2rem'},
          alignSelf: {xs: 'stretch', sm: 'flex-start'},
          maxWidth: '100%',
          minWidth: 0,
        }}>
        {/* scrollable + arrows: on phones the five tabs are wider than the screen */}
        <TabList
          onChange={onTabChange}
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile>
          {_renderHeaders()}
        </TabList>
      </Box>
      {_renderContents()}
    </TabContext>
  );
};

const CustomTab = styled(Tab)`
  &.Mui-selected {
    border-radius: 8px 8px 0 0;
    color: ${theme.palette.primary.contrastText};
    background-color: ${theme.palette.primary.main};
  }
`;

export default TabsContainer;
